import { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from "formik";
import validationSchema from "./index.schema";
import AppInputField from "components/shared/FormComponents/AppInputField";
import LoadingButton from "components/shared/LoadingButton";
import { errorMessageToast, successMessageToast } from "helpers/common";
import close from "../../../Assets/images/cross_icon.png"
// css
import styles from "./index.module.scss";
import CKEditorField from "components/CkEditor/CkEditor";
import { CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { useCreateStrategyTemplateMutation, useGetStartegyTemplatesQuery } from "store/services/clients/reports-v2/recommendationTemplates";
import { useGetDisciplineTagsQuery, useGetLessonsListQuery } from "store/services/utility";
import { useSelector } from "react-redux";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
// import TableLayout from "components/TableLayout";
import moment from "moment";
import { debounce } from "lodash";
import searchIcon from "../../../Assets/icons/searchIcon.png"
import { useNavigate } from "react-router-dom";
import { useGetChatterLessonTagsQuery, useGetLessonListQuery } from "store/services/lesson";
import { useUpdateChatterProgramMutation } from "store/services/chatterPrograms";

const AssignChatterLessonV2 = ({ show, setShow, programDetails, clientType, programId }) => {

    const [currentPage, setCurrentPage] = useState(1)
    const [templateId, setTemplateId] = useState(null)
    const [tags, setTags] = useState([])
    const pageSize = 5;
    const [filter, setFilter] = useState({ tag_id: [], search: "" })
    const [selectedLessons, setSelectedLessons] = useState([]);
    const [disabledLessons, setDisabledLessons] = useState([]);
    const [validation, setValidation] = useState(null)

    const [updateProgram, { isLoading: updateProgramLoading }] = useUpdateChatterProgramMutation();

    const { data: lessonTags, isLoading: lessonTagsLoading } = useGetChatterLessonTagsQuery()
    const lessonTagsOptions = lessonTags?.records?.length > 0 ? lessonTags?.records?.map(tag => ({ value: tag?.id, label: tag?.title })) : [];
    // const { data: lessons, } = useGetLessonListQuery({ page: currentPage, limit: pageSize, ...filter });
    const { data: lessons, isLoading, isError, isFetching } = useGetLessonsListQuery({ page: currentPage, limit: pageSize, ...filter });
    const totalRecords = lessons?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);


    console.log('selectedLessons', selectedLessons)

    const initialValues = {}

    const closePopup = () => {
        setShow(false)
    }

    const column = [
        {
            head: "Name",
            accessor: "name",
            isComponent: true,
            component: (item, ind) => (
                <>
                    <div className="d-flex align-items-center gap-2">
                        <div className="session-input-radio text-area-report">

                            <div className="radio-inputs">
                                <div className="d-flex align-items-center py-1">
                                    {/* <input
                                        type="radio"
                                        id={"table-radio"}
                                        value={item?.id}
                                        onChange={(e) => {
                                            setTemplateId(e.target.value)
                                        }}
                                        checked={item?.id == templateId}
                                    /> */}
                                    {/* <input
                                        type="checkbox"
                                        style={{ height: 20, width: 20 }}
                                        className="form-check"
                                        disabled={disabledLessons.includes(item.id)}
                                        checked={selectedLessons.includes(item.id)}
                                        onChange={e => handleCheck(e.target.checked, item.id)}
                                    /> */}
                                    <input
                                        type="checkbox"
                                        style={{
                                            height: 20,
                                            width: 20,
                                            cursor: disabledLessons.includes(item.id) ? "not-allowed" : "pointer",
                                            accentColor: selectedLessons.includes(item.id) ? "#1976d2" : "#ccc",
                                            opacity: disabledLessons.includes(item.id) ? 0.6 : 1,
                                        }}
                                        className="form-check"
                                        disabled={disabledLessons.includes(item.id)}
                                        checked={selectedLessons.includes(item.id)}
                                        onChange={e => handleCheck(e.target.checked, item.id)}
                                    />

                                    {/* <label className={textMuted && "text-muted"} style={{ marginLeft: "8px", ...labelStyles }}>{option.label || option.name}</label> */}
                                </div>
                            </div>
                        </div>
                        <h6 className="m-0" style={{ color: "#315D99", fontSize: 14 }}>{item?.title}</h6>
                    </div>
                </>
            ),
        },
        // {
        //     head: "Date Created",
        //     accessor: "createdAt",
        //     isComponent: true,
        //     component: (item, ind) => (
        //         <div>{moment(item?.client_detail?.dob).format("DD/MM/YYYY")}</div>
        //     ),
        // },
        {
            head: "Tags",
            accessor: "tags",
            isComponent: true,
            component: (item, ind) => (
                <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                    {item?.lessonTags?.map((tag) => (
                        <button
                            key={tag?.tag_id}
                            type="button"
                            // variant={values.tags?.includes(tag?.value) ? "primary" : "outline-secondary"}
                            className={"select-liberary-btn proxima-regular"}
                        >
                            {tag?.tags?.title}
                        </button>
                    ))}
                </div>
            ),
        },
        // {
        //     head: "Action",
        //     accessor: "",
        //     isComponent: true,
        //     component: (item, index) => (
        //         <ClientsReportMenu
        //             index={index}
        //             client={item}
        //         />
        //     ),
        // },
        // {
        //     head: "Action",
        //     accessor: "",
        //     isComponent: true,
        //     component: (item, index) => (
        //         <div className="ActnBtn d-flex align-items-center  gap-10">
        //             <Dropdown
        //                 onClick={(e) => e.stopPropagation()}
        //             // show={index == dropdownIndex}
        //             // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
        //             >
        //                 <Dropdown.Toggle
        //                     variant="transparent"
        //                     className="p-0 border-0 text-dark w-100"
        //                     id="dropdown-basic"
        //                 >
        //                     <span className="icn ">
        //                         <svg
        //                             xmlns="http://www.w3.org/2000/svg"
        //                             width="28"
        //                             height="13"
        //                             viewBox="0 0 28 13"
        //                             fill="none"
        //                         >
        //                             <rect width="28" height="13" rx="6.5" fill="" />
        //                             <path
        //                                 d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
        //                                 fill="#315D99"
        //                             />
        //                             <path
        //                                 d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
        //                                 fill="#315D99"
        //                             />
        //                             <path
        //                                 d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
        //                                 fill="#315D99"
        //                             />
        //                         </svg>
        //                     </span>
        //                 </Dropdown.Toggle>

        //                 <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
        //                     {
        //                         console.log('item', item)
        //                     }
        //                     <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
        //                         <h5 className="cursor-pointer proxima mb-2" onClick={() => { setCurrentEntry(item); setRecommendationsModal(true) }} style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Edit Template</h5>
        //                         <h5 className="cursor-pointer proxima mb-2" onClick={() => { setCurrentEntry(item); setShowDeleteModal(true) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete Template</h5>
        //                     </ul>
        //                 </Dropdown.Menu>
        //             </Dropdown>
        //         </div>
        //     ),
        // },
    ];

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handleSearch = useCallback(debounce((e) => {
        if (e.target.value) {
            setFilter((prev) => ({ ...prev, search: e.target.value }))
        }
        else {
            setFilter((prev) => ({ ...prev, search: "" }))
        }
    }, 500), [clientType]);

    const handleCheck = (checked, id) => {

        let list = [...selectedLessons];

        if (checked) {

            list.push(id);
            validation && setValidation(null);
        }
        else {

            const index = list.indexOf(id);
            console.log('list and index', list, index)
            if (index > -1) {
                delete list[index];
            };
        };

        setSelectedLessons(list.filter(Boolean));
    };

    const handleSubmit = async () => {

        try {
            if (selectedLessons.length == programDetails?.lessonProgramMapping?.length) {

                setValidation("Please select atleast 1 lesson");
                return;
            }

            const data = {
                lessons: selectedLessons
            };

            const result = await updateProgram({ data, programId }).unwrap()
            if (result?.error) return console.error("Error assigning lesson", result.error);
            closePopup();
            successMessageToast(result?.data?.message);
        } catch (err) { console.error("Error assigning lesson", err); }
    };

    useEffect(() => {

        if (programDetails) {
            setSelectedLessons(programDetails?.lessonProgramMapping?.map(i => i.lesson_id) || []);
            setDisabledLessons(programDetails?.lessonProgramMapping?.map(i => i.lesson_id) || []);
        }

    }, [programDetails]);

    return (
        <Modal
            show={show}
            // show
            className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
            onHide={closePopup}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                <Formik
                    initialValues={initialValues}
                    // validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                        errors,
                        values,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <div className="reports-v2">
                                <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                                    <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"CHOOSE FROM CHATTER LESSONS"}</h6>
                                    <img onClick={closePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                                </div>
                                <Row >
                                    <Col md="12" className="my-2 name-input-v2">
                                        <label
                                            htmlFor=""
                                            className="discharge-screen-label mt-0"
                                        >
                                            Search
                                        </label>
                                        <div className={`${styles.formControl} readonly-box h-auto d-flex justify-content-center`}>
                                            <input
                                                name="title"
                                                style={{ border: 0, width: "100%", outline: "none" }}
                                                placeholder="Type to search for a strategy"
                                                onChange={handleSearch}
                                            />
                                            <img width={21} height={21} src={searchIcon} alt="searchIcon" />
                                        </div>
                                        <div className="btnWrpper mt-2 text-end gap-2 d-flex justify-content-end">
                                            <LoadingButton
                                                style={{ background: "#fff", border: "1px solid #315D99", color: "#315D99", padding: "11px 30px" }}
                                                onClick={closePopup}
                                                type="button"
                                                className="blue-discharge-screen-btn"
                                                disabled={isSubmitting}
                                            >
                                                Cancel
                                            </LoadingButton>

                                            <LoadingButton
                                                type="submit"
                                                className="blue-discharge-screen-btn"
                                                isLoading={isSubmitting}
                                                disabled={isSubmitting}
                                            >
                                                Use Selected Lesson Plans
                                            </LoadingButton>
                                        </div>
                                    </Col>
                                    <Col md="12" className="my-2">
                                        <label className="discharge-screen-label mt-0 mb-0">
                                            Choose Tags
                                        </label>

                                        <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                                            {lessonTagsOptions.map((tag) => (
                                                <button
                                                    key={tag}
                                                    type="button"
                                                    className={filter?.tag_id?.includes(tag?.value) ? "select-liberary-btn proxima-regular" : "non-select-liberary-btn proxima-regular"}
                                                    onClick={() => {
                                                        if (filter?.tag_id?.includes(tag?.value)) {
                                                            const list = filter?.tag_id?.filter((t) => t !== tag?.value)
                                                            setFilter((prev) => ({ ...prev, tag_id: list }))
                                                        } else {
                                                            setFilter((prev) => ({ ...prev, tag_id: [...prev.tag_id, tag?.value] }))
                                                        }
                                                    }}
                                                >
                                                    {tag?.label}
                                                </button>
                                            ))}
                                        </div>
                                    </Col>
                                    <hr className="mt-3" style={{ color: "#000" }} />
                                    <Col lg="12" className="mb-3">
                                        <label className="discharge-screen-label mt-0 mb-0">
                                            Select a Lesson Plan
                                        </label>
                                        <div className="table-outer">
                                            {isError ? (
                                                <ErrorComponent />
                                            ) : (
                                                <>
                                                    {isFetching && <LoadingOverlay />}
                                                    <TableLayout
                                                        data={lessons?.records}
                                                        column={column}
                                                        height={"275px"}
                                                    />
                                                </>
                                            )}
                                            {validation ? <div className="error">{validation}</div> : null}
                                            <CstmPagination
                                                totalPages={totalPages}
                                                className="paginationV2"
                                                activePage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div></Col>
                                </Row>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default AssignChatterLessonV2;



const TableLayout = ({ column, data, url, showHeader = true, noDataMsg = "Data not found", state, handleRowClick, height }) => {
    const navigate = useNavigate();
    return (
        <div className="favorite-goal-wrapper table_height" style={{ height: height || "calc(100vh - 220px)" }}>
            <div className={`${styles.tableResponsive} table-responsive mb-3 h-100`}>
                <table className={`${styles.table} table`}>
                    {showHeader && (
                        <thead>
                            <tr className="">
                                {column &&
                                    column.length > 0 &&
                                    column.map((item, key) => (
                                        <>
                                            <th className="proxima" style={{ borderBottom: "2px solid #315D99", fontWeight: "100" }}>
                                                {item.head}
                                            </th>
                                        </>
                                    ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        {data && data?.length > 0 ? (
                            data.map((data, columnkey) => {
                                return (
                                    <tr
                                        className={`${url && "cursor-pointer"}`}
                                        onClick={(e) => {
                                            url && navigate(`${url}/${data.id}`, { state });
                                            (handleRowClick && typeof handleRowClick == "function") && handleRowClick(data);
                                        }}
                                    >
                                        {column &&
                                            column.length > 0 &&
                                            column.map((item, key) => {
                                                if (item.component) {
                                                    return (
                                                        <td className="proxima" style={{ fontWeight: "100" }}>
                                                            {item.component(data, columnkey, data)}
                                                        </td>
                                                    );
                                                }

                                                return (
                                                    <td className="proxima-regular">{data[item?.accessor] || "--"}</td>
                                                );
                                            })}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={column?.length || 1} className="text-center">
                                    {noDataMsg}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};